<template>
  <div class="side-bar" v-if="!printMode">
    <div class="container">
      <a
        class="button button--red"
        :href="cv.url"
        :download="cv.filename"
        @click="downloadCv"
      >
        <span>{{ cv.display }}</span>
      </a>
      <a
        v-for="(link, i) in links"
        class="button"
        :key="i"
        target="_blank"
        :href="link.url"
      >
        <span>{{ link.display }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { Bus } from "../main";

export default {
  name: "SideBar",
  props: {
    links: {
      type: Array,
      required: true,
    },
    cv: {
      type: Object,
      required: true,
    },
    lang: {
      type: String,
      required: true,
    },
    printMode: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    downloadCv() {
      this.$gtag.event("CV Download", {
        event_category: this.lang,
      });
      Bus.$emit("download-cv");
    },
  },
};
</script>

<style scoped>
.side-bar {
  position: absolute;
  right: -40px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.container {
  position: sticky;
  top: 30mm;
  width: min-content;
  margin-top: 30mm;
}

.button {
  display: flex;
  border: none;
  background: #000000;
  padding: 10px 20px 10px 30px;
  border-radius: 0 2mm 2mm 0;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin-bottom: 4mm;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}

.button:hover {
  transform: translatex(10px);
  background: #ff0000;
  box-shadow: 0 4px 20px rgba(255, 0, 0, 0.3);
}

.button--red {
  background: #ff0000;
}

.button--red:hover {
  background: #cc0000;
}

.button span {
  color: #ffffff;
  font-size: 1.2rem;
  font-weight: 700;
  writing-mode: vertical-lr;
  line-height: 0;
}

@media screen and (max-width: 240mm) {
  .side-bar {
    right: 0;
    z-index: 1;
    top: 0;
    height: unset;
    position: fixed;
    top: 30mm;
  }

  .container {
    display: contents;
  }

  .button {
    border-radius: 2mm 0 0 2mm;
    padding: 8px 24px 8px 16px;
    margin-bottom: 4mm;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
    transform: translatex(8px);
  }

  .button span {
    font-size: 0.8rem;
  }

  .button:hover {
    transform: translatex(0);
  }
}
</style>
